import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal fade show",
  id: "default-example-modal-sm-center",
  tabindex: "-1",
  role: "dialog",
  style: {"display":"block","padding-right":"17px"},
  "aria-modal": "true"
}
const _hoisted_2 = {
  class: "modal-dialog modal-sm modal-dialog-centered",
  role: "document"
}
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = { class: "modal-title" }
const _hoisted_6 = { class: "modal-body" }
const _hoisted_7 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Transition, { name: "slide-fade" }, {
    default: _withCtx(() => [
      (_ctx.showFlag)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", {
              class: "modalOverlay",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeModal()))
            }),
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("h5", _hoisted_5, [
                    _renderSlot(_ctx.$slots, "title", {}, () => [
                      _cache[2] || (_cache[2] = _createTextVNode("modaltitle"))
                    ], true)
                  ]),
                  _createElementVNode("button", {
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.closeModal())),
                    type: "button",
                    class: "close",
                    "data-dismiss": "modal",
                    "aria-label": "Close"
                  }, _cache[3] || (_cache[3] = [
                    _createElementVNode("span", { "aria-hidden": "true" }, [
                      _createElementVNode("i", { class: "fal fa-times" })
                    ], -1)
                  ]))
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _renderSlot(_ctx.$slots, "body", {}, () => [
                    _cache[4] || (_cache[4] = _createTextVNode("..."))
                  ], true)
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _renderSlot(_ctx.$slots, "footer", {}, undefined, true)
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 3
  }))
}